Ext.define('SA.Json', {
    singleton: true,

    differ(valueA, valueB) {
        return !this.equal(valueA, valueB);
    },

    equal(valueA, valueB) {
        return JSON.stringify(valueA) === JSON.stringify(valueB);
    },

    parse(string) {
        var json, jsonValid, jsonError;

        try {
            json = JSON.parse(string);
            jsonValid = true;
            jsonError = null;
        }
        catch (e) {
            json = null;
            jsonValid = false;
            jsonError = e;
        }

        return {json, jsonValid, jsonError};
    }
});